import { render, staticRenderFns } from "./comp-nav.vue?vue&type=template&id=99cf4320&scoped=true"
import script from "./comp-nav.vue?vue&type=script&lang=js"
export * from "./comp-nav.vue?vue&type=script&lang=js"
import style0 from "./comp-nav.vue?vue&type=style&index=0&id=99cf4320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cf4320",
  null
  
)

export default component.exports